// tslint:disable-next-line:no-shadowed-variable
import { ConfigModel } from '../core/interfaces/config';

// tslint:disable-next-line:no-shadowed-variable
export class MenuConfig implements ConfigModel {
	public config: any = {};

	PREFIX_URL = '/pages';

	constructor() {
		this.config = {
			header: {
				self: {},
				items: [
					{
						title: 'Menu de exemplo',
						root: true,
						icon: 'flaticon-add',
						toggle: 'click',
						translate: 'MENU.ACTIONS',
					},
				]
			},
			aside: {
				self: {},
				items: [
					{
						title: 'Dashboards',
						root: true,
						bullet: 'dot',
						icon: 'flaticon-line-graph',
						page: '/',
						submenu: [
							{
								title: 'Visão Tático Operacional',
								root: true,
								icon: 'fas fa-building',
								page: this.PREFIX_URL + '/paineis/tatico-operacional',
							},
							{
								title: 'Nível de Servico Logístico - OTIF',
								root: true,
								icon: 'fas fa-truck',
								page: this.PREFIX_URL + '/paineis/nivel-servico-logistico',
							},
							{
								title: 'Visão Gerencial',
								root: true,
								icon: 'fas fa-eye',
								page: this.PREFIX_URL + '/paineis/visao-gerencial'
							},
							{
								title: 'Painel de Monitoramento',
								root: true,
								icon: 'fas fa-th',
								page: this.PREFIX_URL + '/paineis/painel-monitoramento',
							},
							{
								title: 'Controle de Portaria',
								icon: 'fas fa-door-open',
								page: this.PREFIX_URL + '/paineis/controle-portaria'
							},
							{
								title: 'Indicadores de Entregas',
								icon: 'fas fa-chart-line',
								page: this.PREFIX_URL + '/paineis/indicadores-de-entrega'
							},
							{
								title: 'Painel de Custos - Tabela Frete',
								icon: 'fas fa-truck-loading',
								page: this.PREFIX_URL + '/paineis/custos-tabela-frete'
							},
							{
								title: 'Produtividade por Motorista',
								icon: 'fa fa-id-card',
								page: this.PREFIX_URL + '/paineis/produtividade-por-motorista'
							},
							{
								title: 'Retornos de Viagem',
								icon: 'fas fa-truck-moving',
								page: this.PREFIX_URL + '/paineis/retornos-de-viagem'
							},
							{
								title: 'Análise de Entregas/Romaneios',
								root: true,
								icon: 'far fa-chart-bar',
								page: this.PREFIX_URL + '/consultas/grafico-entrega',
							},
							{
								title: 'Despesas',
								root: true,
								icon: 'far fa-chart-bar',
								page: this.PREFIX_URL + '/consultas/grafico-despesa',
							},
						]
					},
					{
						title: 'Relatórios',
						root: true,
						bullet: 'dot',
						icon: 'fas fa-clipboard-list',
						submenu: [
							{
								title: 'Notas Fiscais Pendentes',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/notas-pendentes',
							},
							{
								title: 'Notas Fiscais por Situação',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/notas-situacao',
							},
							{
								title: 'Registros de Jornadas',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/registros-jornada',
							},
							{
								title: 'Apuração de Campanha',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/apuracao',
							},
							{
								title: 'Entregas Realizadas',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/entregas-realizadas',
							},
							{
								title: 'Entregas Consolidado',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/consolidacao-entrega',
							},
							{
								title: 'Geolocalização entregas x clientes',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/geolocalizacao',
							},
							{
								title: 'Hodômetro',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/hodometro',
							},
							{
								title: 'Despesas',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/despesas',
							},
							{
								title: 'Percentuais de Entrega, Valores e Peso',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/percentual-entrega',
							},
							{
								title: 'Tempo / desempenho motorista',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/desempenho-motorista',
							},
							{
								title: 'Motoristas Envolvidos no Período',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/motorista-envolvido',
							},
							{
								title: 'Ocorrências por carregamento',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/ocorrencias-carregamento',
							},
							{
								title: 'Análise de TMA por Cliente',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/tempo-entrega-cliente',
							},
							{
								title: 'Custo Previsto X Realizado Romaneio',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/custo-previsto-realizado',
							},
							{
								title: 'Ocorrências Ocoren',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/ocorrencias-ocoren',
							},
							{
								title: 'Canhotos',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/canhotos',
							},
							{
								title: 'Tabela Frete',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/tabela-frete',
							},
							{
								title:'Operacional/ Carregamento  e Entrega',
								root: true,
								icon: 'fas fa-clipboard-list',
								page: this.PREFIX_URL + '/relatorios/operacional-carregamento',
							},
							{
								title: 'Tempos',
								root: true,
								bullet: 'dot',
								icon: 'fas fa-sort-amount-down',
								submenu: [
									{
										title: 'Tempo no Cliente',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/relatorios/tempo-cliente',
									},
									{
										title: 'Tempo de Espera do Pedido',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/relatorios/tempo-espera-pedido',
									},
									{
										title: 'Tempo Médio no Cliente',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/consultas/tempo-cliente',
									},
									{
										title: 'Tempo Médio em Entrega',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/consultas/tempo-entrega',
									},
									{
										title: 'Tempo Médio do Pedido',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/consultas/tempo-pedido',
									},
									{
										title: 'Tempo Médio Aguardando no Cliente',
										root: true,
										icon: 'fas fa-sort-amount-down',
										page: this.PREFIX_URL + '/consultas/tempo-aguardando',
									}
								]
							}
						]
					},
					{
						title: 'Cadastros',
						root: true,
						bullet: 'dot',
						icon: 'fas fa-pencil-alt',
						submenu: [
							{
								title: 'Centro de Distribuição',
								root: true,
								icon: 'fas fa-building',
								page: this.PREFIX_URL + '/cadastros/centro-distribuicao',
							},
							{
								title: 'Clientes',
								root: true,
								icon: 'fas fa-user-friends',
								page: this.PREFIX_URL + '/consultas/clientes',
							},
							{
								title: 'Motivo',
								root: true,
								bullet: 'dot',
								icon: 'fas fa-pen',
								submenu: [
									{
										title: 'Devolução',
										root: true,
										icon: 'fas fa-reply',
										page: this.PREFIX_URL + '/consultas/motivo-devolucao',
									},
									{
										title: 'Cancelamento',
										root: true,
										icon: 'fas fa-undo',
										page: this.PREFIX_URL + '/configuracoes/motivo-cancelamento',
									},
									{
										title: 'Furo de Sequência',
										root: true,
										icon: 'fas fa-undo',
										page: this.PREFIX_URL + '/configuracoes/motivo-furo-sequencia',
									},
									{
										title: 'Reagendamento',
										root: true,
										icon: 'fas fa-undo',
										page: this.PREFIX_URL + '/configuracoes/motivo-reagendamento',
									},
									{
										title: 'Ocorrências',
										root: true,
										icon: 'fas fa-undo',
										page: this.PREFIX_URL + '/configuracoes/motivo-ocorrencia',
									},
									{
										title: 'Canhoto',
										root: true,
										icon: 'fas fa-undo',
										page: this.PREFIX_URL + '/cadastros/motivo-de-canhoto',
										dialog: false
									},
								]
							},
							{
								title: 'Jornadas',
								root: true,
								bullet: 'dot',
								icon: 'far fa-clock',
								submenu: [
									{
										title: 'Jornada',
										root: true,
										icon: 'far fa-clock',
										page: this.PREFIX_URL + '/cadastros/jornadas',
									},
									{
										title: 'Ausência Registro de Jornada',
										root: true,
										icon: 'la la-check-square-o',
										page: this.PREFIX_URL + '/cadastros/ausencia-registro-jornada'
									},
									{
										title: 'Horários de Trabalho',
										root: true,
										icon: 'far fa-clock',
										page: this.PREFIX_URL + '/cadastros/horario-trabalho',
									},
								]
							},
							{
								title: 'Contatos',
								root: true,
								icon: 'fas fa-address-book',
								page: this.PREFIX_URL + '/cadastros/contatos',
							},
							{
								title: 'Visão Painel Gerencial',
								root: true,
								icon: 'fas fa-chart-pie',
								page: this.PREFIX_URL + '/cadastros/visao-painel',
							},
							{
								title: 'MaxPag',
								root: true,
								icon: 'icon-maxpag',
								page: this.PREFIX_URL + '/cadastros/max-pag',
								dialog: false,
								bannerLink: 'https://conteudos.maximatech.com.br/maxpag?utm_source=referral&utm_medium=banner&utm_campaign=maxpag-banner-maxmotorista',
								bannerImagePath: './assets/app/media/img/maxpag/banner.png'
							},
							{
								title: 'Dias Utéis',
								root: true,
								icon: 'far fa-calendar-check',
								page: this.PREFIX_URL + '/cadastros/dias-uteis',
								dialog: false
							},
							{
								title: 'Pontos de Referência',
								root: true,
								icon: 'fas fa-bullseye',
								page: this.PREFIX_URL + '/cadastros/pontos-referencia',
								dialog: false
							},
						]
					},
					{
						title: 'Consultas',
						root: true,
						bullet: 'dot',
						icon: 'fas fa-search',
						submenu: [
							{
								title: 'Listagem de Romaneios',
								root: true,
								icon: 'fas fa-truck-loading',
								page: this.PREFIX_URL + '/consultas/romaneios',
							},
							{
								title: 'Listagem de Carregamentos',
								root: true,
								icon: 'fas fa-truck',
								page: this.PREFIX_URL + '/consultas/carregamentos',
							},
							{
								title: 'Despesas',
								root: true,
								bullet: 'dot',
								icon: 'fas fa-dollar-sign',
								submenu: [
									{
										title: 'Tipos de Despesas',
										root: true,
										icon: 'fas fa-dollar-sign',
										page: this.PREFIX_URL + '/configuracoes/tipo-despesa',
									},
									{
										title: 'Despesas do aplicativo',
										root: true,
										icon: 'fas fa-dollar-sign',
										page: this.PREFIX_URL + '/consultas/despesas',
									}
								]
							},
							{
								title: 'Entregas',
								root: true,
								icon: 'fas fa-suitcase',
								page: this.PREFIX_URL + '/consultas/entregas',
							},
							{
								title: 'Hodômetros',
								root: true,
								icon: 'fas fa-tachometer-alt',
								page: this.PREFIX_URL + '/consultas/hodometros',
							},
							{
								title: 'Reentregas',
								root: true,
								icon: 'fas fa-suitcase',
								page: this.PREFIX_URL + '/consultas/notas-reentrega',
							},
							{
								title: 'Recebíveis',
								root: true,
								icon: 'fas fa-money-bill',
								page: this.PREFIX_URL + '/consultas/recebiveis',
							},
							{
								title: 'Cidades',
								root: true,
								icon: 'fa fa-building',
								page: this.PREFIX_URL + '/consultas/cidades',
							},
							{
								title: 'Eventos',
								root: true,
								bullet: 'dot',
								icon: 'far fa-calendar-alt',
								submenu: [
									{
										title: 'Detalhes dos Eventos',
										root: true,
										icon: 'far fa-calendar-alt',
										page: this.PREFIX_URL + '/consultas/eventos',
									},
									{
										title: 'Tipos de Evento',
										root: true,
										icon: 'far fa-calendar-alt',
										page: this.PREFIX_URL + '/configuracoes/tipo-evento',
									}
								]
							},
							{
								title: 'Descargas Canceladas',
								root: true,
								icon: 'fas fa-undo-alt',
								page: this.PREFIX_URL + '/consultas/descargas-canceladas',
							},
							{
								title: 'Log de Sincronização do Motorista',
								root: true,
								icon: 'fas fa-sync-alt',
								page: this.PREFIX_URL + '/consultas/sincronizacao-motorista',
							},
							{
								title: 'Registro de pontos de parada',
								root: true,
								icon: 'fas fa-map-marker-alt',
								page: this.PREFIX_URL + '/consultas/pontos-parada',
							},
							{
								title: 'Auditoria de Coordenadas de Entrega',
								root: true,
								icon: 'fas fa-map-marked-alt',
								page: this.PREFIX_URL + '/consultas/auditoria-coordenadas-entrega',
							},
							{
								title: 'Veículos',
								root: true,
								icon: 'fa fa-bus',
								page: this.PREFIX_URL + '/consultas/veiculos',
							},
							{
								title: 'Comodatos',
								root: true,
								bullet: 'dot',
								icon: 'fa fa-archive',
								submenu: [
									{
										title: 'Itens Comodatos',
										root: true,
										icon: 'las la-boxes',
										page: this.PREFIX_URL + '/consultas/itens-comodatos',
									},
									{
										title: 'Lançamentos Comodatos',
										root: true,
										icon: 'las la-luggage-cart',
										page: this.PREFIX_URL + '/consultas/lancamentos-comodatos',
									},
								]
							}
						]
					},
					{
						title: 'Autorizações',
						root: true,
						bullet: 'dot',
						icon: 'fa fa-check-double',
						submenu: [
							{
								title: 'Autorizar Entrega fora do Raio',
								root: true,
								icon: 'fa fa-map-marker-alt',
								page: this.PREFIX_URL + '/autorizacoes/autorizacao-checkin-fora-raio',
							},
						]
					},
					{
						title: 'OCOREN',
						root: true,
						bullet: 'dot',
						icon: 'la la-file-text-o',
						submenu: [
							{
								title: 'Importar',
								icon: 'fa fa-file-import',
								page: `${this.PREFIX_URL}/importacao-ocoren`
							}
						]
					},
					{
						title: 'Mapas',
						root: true,
						bullet: 'dot',
						icon: 'fas fa-map-marked-alt',
						submenu: [
							{
								title: 'Monitoramento de entregas',
								root: true,
								icon: 'fas fa-route',
								page: this.PREFIX_URL + '/torre-de-controle/monitoramento-entregas',
							},
							{
								title: 'Monitoramento do Motorista',
								icon: 'fa fa-road',
								page: this.PREFIX_URL + '/paineis/monitoramento-motorista'
							}
						]
					},
					{
						title: 'Ocorrências',
						root: true,
						bullet: 'dot',
						icon: 'fas fa-newspaper',
						submenu: [
							{
								title: 'Gerenciamento de Ocorrências',
								root: true,
								icon: 'fa fa-laptop',
								page: this.PREFIX_URL + '/ocorrencias/ocorrencias-listagem',
							}
						]
					},
					{
						title: 'Configurações',
						bullet: 'dot',
						icon: 'la la-cog',
						submenu: [
							{
								title: 'Usuários',
								root: true,
								icon: 'fas fa-user-friends',
								page: this.PREFIX_URL + '/cadastros/usuarios',
							},
							{
								title: 'Perfil de Acesso',
								icon: 'la la-user',
								page: `${this.PREFIX_URL}/configuracoes/perfis-acesso`
							},
							{
								title: 'Portal',
								icon: 'la la-cog',
								page: `${this.PREFIX_URL}/configuracoes/parametros-portal`
							},
							{
								title: 'Aplicativo',
								icon: 'la la-cog',
								page: `${this.PREFIX_URL}/configuracoes/parametros-aplicativo`
							},
							{
								title: 'Administrativo',
								icon: 'la la-cog',
								page: `${this.PREFIX_URL}/configuracoes/parametros-administrativos`
							},
							{
								title: 'Logo da Empresa',
								icon: 'la la-file-image-o',
								page: `${this.PREFIX_URL}/ferramentas/logo-empresa`
							},
							{
								title: 'Geração de coordenadas/Geocode',
								icon: 'la la-exchange',
								page: `${this.PREFIX_URL}/ferramentas/importar-localizacao`
							},
							{
								title: 'E-mail',
								icon: 'la la-envelope',
								page: `${this.PREFIX_URL}/ferramentas/configuracao-email`
							},
							{
								title: 'Rastreador',
								icon: 'fa fa-globe',
								page: `${this.PREFIX_URL}/ferramentas/configuracao-rastreadores`
							},
							{
								title: 'Whatsapp',
								icon: 'la la-whatsapp',
								page: `${this.PREFIX_URL}/ferramentas/configuracao-timeline-whatsapp`,
								msgSemAcesso: "Para acessar este item, ative o parâmetro 'Notificar status da entrega via Whatsapp' em 'Configurações > Portal'."
							}
						]
					},

					{
						title: 'MaxInsights',
						root: true,
						icon: 'icon-maxinsights',
						dialog: true,
						isExternalLink: true,
						bannerLink: 'https://conteudos.maximatech.com.br/maxinsights',
						bannerImagePath: './assets/app/media/img/maxinsights/banner.png',
						page: '',
						msgSemAcesso: ''
					}
				]
			}
		};
	}
}
